import AuthRedirect from "./AuthRedirect";

export { AuthRedirect };

export default AuthRedirect;
